//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Footer from "@/components/lyx-components/lyx-footer/index"
    import EsQuery from "@/javascript/esQuery";
    import tabWrap from "@/components/lyx-components/tab-wrap/index.vue";
    import goSearch from "@/components/lyx-components/search-box/index.vue";
    import Swiper from "swiper";
    import "swiper/dist/css/swiper.css";
    import menus from "@/components/lyx-components/menus/index";
    import util from "@/javascript/util";
    import {formatDate} from "@/javascript/formatDate";
    import bus from "@/javascript/bus";

    export default {
        components: {
            menus,
            tabWrap,
            goSearch,
            Footer,
        },
        data() {
            return {
                menuSlide: false,
                isWeixin: util.isWeiXin(),
                cityCode: this.$route.params.cityCode,
                searchSticky: false,
                tabsSticky: false,
                infiniteStatus: false,
                infiniteAll: false,
                slideUp: false,
                coverShow: false,
                videoShow: false,
                videoUrl: "",
                videoUrl2: "",
                bannerList: [],
                newListData: [],
                localPosition: {},
                scenicList: [],
                videoList: [],
                cityData: [],
                strategyList: [],
                tabsList: [],
                hotelList: [],
                foodData: [],
                goodPlace: [],
                glDesData: "",
                curTab: 0,
                cityId: "",
                // tabs: ["景区", "攻略", "游记", "全景"],
                tabs: ["景区", "攻略", "游记"],
                tabActive: 0,
                foodName: "",
                foodId: "",
                foodList: [],
                defautActive: 0,
                tabsListPageNo: 0,
                tabsListPageSize: 10,
                bannerData: [],
                cityName: {},
                userInfo: bus.userInfo.user ? bus.userInfo.user : {},
                isLogin: Boolean(bus.userInfo.access_token),
                foodMenu: [],
                begfoodData: [],
                foodListPageNo: 0,
                foodListPageSize: 5,
                areaCode: "630202",
                indexVideo: [],
                xclyList: [],
                showState: false,
                classify: "",
                villageList: [],
                villageBefore: [],
                imgList: [],
                gallery: [],
                routeList: [],
                vrListData: [],
                showPic: true,
                showVideo: false,
                onePlay: "",
                galleryshow: false,
                indexLength: 0,
                flagVideo: "",
                navImg: {
                    navlyzx: "navlyzx.svg",
                    oneMoer: "oneMoer.svg",
                },
                minHeight: 0,
                menuFlag:false,
                menuData: [
                    [
                        {
                            title: "景区",
                            link: "/scenicList",
                            icon: require("../../../assets/lyx-img/jq_icon.png"),
                            flag:true
                        },
                        {
                            title: "酒店",
                            link: "/hotelList",
                            icon: require("../../../assets/lyx-img/jd_icon.png"),
                            flag:true

                        },
                        {
                            title: "美食",
                            link: "/delicious-food",
                            icon: require("../../../assets/lyx-img/ms_icon.png"),
                            flag:true

                        },
                        {
                            title: "攻略",
                            link: "/strList",
                            icon: require("../../../assets/lyx-img/gl_icon.png"),
                            flag:true

                        },
                        {
                            title: "文博专题",
                            link: "/culture",
                            icon: require("../../../assets/lyx-img/wbzt_icon.png"),
                            flag:true

                        },
                        {
                            title: "慢直播",
                            link: "/directList",
                            icon: require("../../../assets/lyx-img/csfw_icon.png"),
                            flag:true

                        },
                        {
                            title: "海晏全景",
                            link: "/videoList/0",
                            icon: require("../../../assets/lyx-img/sjly_icon.png"),
                            flag:true

                        },
                        {
                            title: "乡村游",
                            link: "/agritainmentList",
                            icon: require("../../../assets/lyx-img/njl_icon.png"),
                            flag:true

                        },
                        {
                            title: "周边游",
                            link: "/peripheral",
                            icon: require("../../../assets/lyx-img/zby_icon.png"),
                            flag:true

                        },
                        {
                            title: "非遗",
                            link: "/legacy",
                            icon: require("../../../assets/lyx-img/legacy_icon.png"),
                            flag:true

                        }

                    ],
                    [
                        // {
                        //   title: "行程定制",
                        //   link: "/travel-choice",
                        //   icon: require("../../../assets/lyx-img/xcdz_icon.png"),
                        // },

                        // {
                        //   title: "非遗",
                        //   link: "/legacy",
                        //   icon: require("../../../assets/lyx-img/njl_icon.png"),
                        // },
                        {
                            title: "投诉",
                            link: "/complaintImtion",
                            icon: require("../../../assets/lyx-img/icon41.png"),
                            flag:false

                        },
                        {
                            title: "生态专题",
                            link: "/ecological",
                            icon: require("../../../assets/lyx-img/stzt_icon.png"),
                            flag:false

                        },
                        {
                            title: "智能问答",
                            link: "/consultation",
                            icon: require("../../../assets/lyx-img/znwd_icon.png"),
                            flag:false

                        },
                        {
                            title: "游记",
                            link: "/strategyList/0",
                            icon: require("../../../assets/lyx-img/yj_icon.png"),
                            flag:false

                        },
                        {
                            title: "资讯",
                            link: "/information?code=00000000,1720488224033",
                            icon: require("../../../assets/lyx-img/zx_icon.png"),
                            flag:false

                        }

                    ],
                ],
            };
        },
        filters: {
            // 格式化时间戳
            formatDate(datestamp) {
                if (datestamp != null) {
                    let result = new Date(Number(datestamp));
                    const y = result.getFullYear();
                    let m = result.getMonth() + 1;
                    m = m < 10 ? "0" + m : m;
                    let d = result.getDate();
                    d = d < 10 ? "0" + d : d;
                    let h = result.getHours();
                    h = h < 10 ? "0" + h : h;
                    let n = result.getMinutes();
                    n = n < 10 ? "0" + n : n;
                    let s = result.getSeconds();
                    s = s < 10 ? "0" + s : s;
                    return `${y}-${m}-${d}`;
                }
            },
        },
        mounted() {
            document.title = this.PAGE_TITLE + "公众服务门户";
            this.minHeight = document.documentElement.clientHeight

            /**
             * 页面滚动
             */
            window.addEventListener("scroll", this.windowScroll);
            this.getTabsList();
            // this.getSwiper();
            this.newList();
            this.getCommentList();
            this.getlineList();
            this.getVideo();
            this.getGuideList();
            this.vrList();
            this.getBannerData();

            new Swiper(".home-menu", {
                pagination: ".swiper-scrollbar",
            });
        },
        // computed: {
        //   videoPlay2() {
        //     this.$refs.videoOne.play()
        //   }

        // },

        methods: {
          setmenuFlag(flag){
      if(flag==='true'){
        this.menuFlag=true
        for(let i=0;i<this.menuData[1].length;i++){
          this.menuData[1][i].flag=true
        }
      }else{
        this.menuFlag=false
        for(let i=0;i<this.menuData[1].length;i++){
          this.menuData[1][i].flag=false
        }
      }
    },
            windowScroll: function () {
                const scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;

                // 精选、景区、门票等tab栏滚动固定
                if (!this.$refs.stickyBox) {
                    return;
                }
                if (
                    scrollTop >=
                    this.$refs.stickyBox.offsetTop
                ) {
                    this.tabsSticky = true;
                } else {
                    this.tabsSticky = false;
                }
                // 底部加载
                if (util.pullUpLoad()) {
                    this.infinite();
                }
            },

            tabsClick(e) {
                this.curTab = e;
                this.tabActive = e;
                this.tabsListPageNo = 0;
                this.infiniteAll = false;
                this.infiniteStatus = true;
                this.getTabsList(true);
                this.tabsList = [];
                this.slideLeft(e);
            },
            coverCancel() {
                this.slideUp = false;
                this.coverShow = false;
            },
            slideLeft(e) {
                let list = document.getElementsByClassName("slide-li"),
                    lefWidth = 0;
                lefWidth = list[e].offsetLeft / 4.5;
                this.$refs.slideTab.scrollLeft = lefWidth;
            },
            videoPlay() {
                this.$refs.video.play();
            },

            videoStop() {
                this.$refs.video.pause();
                // this.$refs.video.end()
                this.videoUrl = "";
                this.showState = false;
                this.showPic = true;
            },

            videostart(index) {
                this.onePlay =
                    this.videoList[index].link != ""
                        ? this.videoList[index].link
                        : this.PIC_BASE_URL + this.videoList[index].videos[0][0].fileUrl;
                // this.videoList[index]._source.link
                this.showPic = false;
                this.showVideo = true;
                const that = this;
                if (this.onePlay != "") {
                    // if(that.$refs.oneVideo.buffered()){
                    //     setTimeout(function () {
                    //      that.$refs.oneVideo.buffered()
                    //     }, 200)
                    // }else{
                    setTimeout(function () {
                        that.$refs.oneVideo.play();
                    }, 200);
                    // }
                }
            },
            videoStopOne() {
                this.showPic = true;
                this.showVideo = false;
                this.onePlay = "";
            },

            getBannerData() {
                const videoList = new EsQuery();
                const querystring = require("querystring");
                videoList
                    // .addString(
                    //   "catalogId",
                    //   "20e260ebe4a94102905376032ff659d6",
                    //   videoList.and,
                    //   false
                    // )
                    .addStartWith(
                        "catalogCode",
                        "00000000,1720424040492",
                        videoList.and,
                        false
                    )
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, videoList.and, false)
                    .addString("publishStatus", 1, videoList.and, false)
                    .addSort("weight", videoList.desc, false);
                const video = JSON.stringify(videoList.getArray());
                this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring.stringify({
                            indexName: this.INDEX_NAME_TYPE.newsList,
                            esJsonQuery: video,
                        })
                    )
                    .then((res) => {
                        this.bannerList = res.data.data;
                    })
                    .then(() => {
                        new Swiper(".home-swiper-banner", {
                            autoplay: 7000,
                            speed: 500,
                            observer: true,
                            loop: true,
                            autoplayDisableOnInteraction: true,
                            centeredSlides: true,
                            pagination: ".swiper-pagination",
                            paginationClickable: true,
                        });
                    })
                    .then(() => {
                        this.bannerList.map((item) => {
                            if (item._source && item._source.videos) {
                                this.$refs.videoOne.play();
                            }
                        });
                    });
            },

            // 精选、景区、攻略、门票tab切换
            getTabsList: function (status) {
                const _this = this;
                switch (this.curTab) {
                    case 0:
                        // 景区
                        const querystring = require("querystring");
                        const recommendEsQuery = new EsQuery();
                        recommendEsQuery
                            .addString(
                                "category",
                                this.XXCJ_TYPE_CODE.JQ,
                                recommendEsQuery.and,
                                false
                            )
                            .addStartWith(
                                "deptCode",
                                this.DEPT_CODE.DEPTCODE,
                                recommendEsQuery.and,
                                false
                            )
                            // .addSort("level.keyword", recommendEsQuery.desc, false)
                            .addSort("weight", recommendEsQuery.desc, false);
                        recommendEsQuery.addPage(
                            this.tabsListPageNo * this.tabsListPageSize,
                            this.tabsListPageSize
                        );
                        const recommendEsJsonQuery = JSON.stringify(
                            recommendEsQuery.getArray()
                        );
                        this.$http
                            .post(
                                "/api/wtcp-kb/pub/doc/search",
                                querystring.stringify({
                                    indexName: this.INDEX_NAME_TYPE.scenic,
                                    esJsonQuery: recommendEsJsonQuery,
                                })
                            )
                            .then((response) => {
                                const scenics = response.data.data,
                                    scenics2 = scenics.map((scenic) => {
                                        scenic._source.images[0].map((img) => {
                                            if (img.fileIdentify.indexOf("titleImage") != -1) {
                                                scenic._source.titleImage = img.fileUrl;
                                            }
                                        });
                                        return scenic._source;
                                    });
                                this.tabsList = this.tabsList.concat(scenics2);
                                if (response.data.data.length < this.tabsListPageSize) {
                                    this.infiniteAll = true;
                                }
                                this.infiniteStatus = false;
                            })
                            .then(() => {
                                if (status && this.$refs.stickyBox) {
                                    window.scrollTo(
                                        0,
                                        this.$refs.stickyBox.offsetTop
                                    );
                                }
                            });
                        break;
                    case 1:
                        // 攻略
                        const querystring3 = require("querystring");
                        const strategyEsQuery3 = new EsQuery();
                        strategyEsQuery3
                            .addStartWith(
                                "deptCode",
                                this.DEPT_CODE.DEPTCODE,
                                strategyEsQuery3.and,
                                false
                            )
                            .addPage(
                                this.tabsListPageNo * this.tabsListPageSize,
                                this.tabsListPageSize
                            );
                        // .addString("publishStatus", 1, strategyEsQuery3.and, false)
                        // .addSort("weight", strategyEsQuery3.desc, false)
                        // if (this.$route.query.type && this.$route.query.type == "z") {
                        //   strategyEsQuery3.addString("kind", 2, strategyEsQuery3.and, false);
                        // } else {
                        //   strategyEsQuery3.addString("kind", 1, strategyEsQuery3.and, false);
                        // }
                        const strategyEsJsonQuery3 = JSON.stringify(
                            strategyEsQuery3.getArray()
                        );
                        this.$http
                            .post(
                                "api/wtcp-kb/pub/doc/search",
                                querystring3.stringify({
                                    indexName: "wtcp-tips",
                                    esJsonQuery: strategyEsJsonQuery3,
                                })
                            )
                            .then((response) => {
                                const strategyList = response.data.data;
                                strategyList.forEach(
                                    (item) =>
                                        (item._source.updatedDate = formatDate(
                                            item._source.updatedDate,
                                            "yyyy-MM-dd"
                                        ))
                                );
                                const strategyList2 = strategyList.map((scenic) => {
                                    return scenic._source;
                                });
                                this.tabsList = this.tabsList.concat(strategyList2);
                                if (response.data.data.length < this.tabsListPageSize) {
                                    this.infiniteAll = true;
                                }
                                this.infiniteStatus = false;
                            })
                            .then(() => {
                                if (status && this.$refs.stickyBox) {
                                    window.scrollTo(
                                        0,
                                        this.$refs.stickyBox.offsetTop
                                    );
                                }
                            });
                        break;
                    case 2:
                        // 游记
                        const querystring2 = require("querystring");
                        const travelsEsQuery = new EsQuery();
                        travelsEsQuery
                            .addStartWith(
                                "deptCode",
                                this.DEPT_CODE.DEPTCODE,
                                travelsEsQuery.and,
                                false
                            )
                            .addString("publishStatus", 1, travelsEsQuery.and, false)
                            // .addPattern("noteType", '*1*', travelsEsQuery.and, false)
                            // .addSort("updateDate", travelsEsQuery.desc, false)
                            .addPage(
                                this.tabsListPageNo * this.tabsListPageSize,
                                this.tabsListPageSize
                            );
                        const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray());
                        this.$http
                            .post(
                                "/api/wtcp-kb/pub/doc/search",
                                querystring2.stringify({
                                    indexName: this.INDEX_NAME_TYPE.travelList,
                                    esJsonQuery: travelsEsJsonQuery,
                                })
                            )
                            .then((response) => {
                                const commentList = response.data.data;
                                // commentList.forEach(
                                //   (item) =>
                                //   (item._source.updateDate = formatDate(
                                //     item._source.updateDate,
                                //     "yyyy-MM-dd"
                                //   ))
                                // );
                                this.tabsList = this.tabsList.concat(commentList);
                                if (response.data.data.length < this.tabsListPageSize) {
                                    this.infiniteAll = true;
                                }
                                this.infiniteStatus = false;
                            })
                            .then(() => {
                                if (status && this.$refs.stickyBox) {
                                    window.scrollTo(
                                        0,
                                        this.$refs.stickyBox.offsetTop
                                    );
                                }
                            });
                        break;

                    case 3:
                        //全景
                        const newsEsQuery = new EsQuery();
                        const querystring6 = require("querystring");
                        newsEsQuery
                            .addStartWith(
                                "deptCode",
                                this.DEPT_CODE.DEPTCODE,
                                newsEsQuery.and,
                                false
                            )
                            .addString("publishStatus", 1, newsEsQuery.asc, false)
                            .addSort("createdDate", newsEsQuery.desc, false);

                        newsEsQuery.addPage(
                            this.tabsListPageNo * this.tabsListPageSize,
                            this.tabsListPageSize
                        );
                        newsEsQuery.addStartWith(
                            "catalogCode",
                            "00000000,1720424059487",
                            newsEsQuery.and,
                            false
                        );
                        const newsJsList2 = JSON.stringify(newsEsQuery.getArray());

                        this.$http
                            .post(
                                "/api/wtcp-kb/pub/doc/search",
                                querystring6.stringify({
                                    indexName: this.INDEX_NAME_TYPE.newsList,
                                    esJsonQuery: newsJsList2,
                                })
                            )
                            .then((response) => {
                                const quanjingList = response.data.data;

                                this.tabsList = this.tabsList.concat(quanjingList);
                                if (response.data.data.length < this.tabsListPageSize) {
                                    this.infiniteAll = true;
                                }
                                this.infiniteStatus = false;
                            })
                            .then(() => {
                                if (status && this.$refs.stickyBox) {
                                    window.scrollTo(
                                        0,
                                        this.$refs.stickyBox.offsetTop
                                    );
                                }
                            });
                        break;
                }
            },
            infinite: function () {
                if (this.infiniteAll) {
                    return;
                }
                if (this.infiniteStatus) {
                    return;
                }
                this.infiniteStatus = true;
                this.tabsListPageNo += 1;
                this.getTabsList();
            },
            closeSlide() {
                this.slideUp = false;
                this.coverShow = false;
            },
            slideItem(e) {
                this.curTab = e;
                this.tabActive = e;
                this.tabsListPageNo = 0;
                this.infiniteAll = false;
                this.infiniteStatus = true;
                this.getTabsList(true);
                this.tabsList = [];
                this.slideLeft(e);
                this.slideUp = false;
                this.coverShow = false;
            },
            goDetails(item) {
                if (item.link) {
                    window.location.href = item.link;
                } else {
                    this.$router.push({path: `/news-details?id=${item.id}`});
                }
            },
            menuClick() {
                this.menuSlide = !this.menuSlide;
            },
            // 页面带参数跳转
            gotoPageParam(path, obj) {
                this.$router.push({
                    path: path,
                    query: obj,
                });
            },
            //乡村旅游列表改为非遗传承
            getGuideList() {
                const querystring11 = require("querystring");
                const recommendEsQuery = new EsQuery();
                recommendEsQuery
                    // .addString(
                    //   "category",
                    //   this.XXCJ_TYPE_CODE.FYLX,
                    //   recommendEsQuery.and,
                    //   false
                    // )
                    .addStartWith(
                        "deptCode",
                        this.DEPT_CODE.DEPTCODE,
                        recommendEsQuery.and,
                        false
                    )
                    .addPage(this.pageNo * this.pageSize, this.pageSize)
                    .addSort("weight", recommendEsQuery.desc, false);
                const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray());
                this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring11.stringify({
                            indexName: this.INDEX_NAME_TYPE.heritage,
                            esJsonQuery: recommendEsJsonQuery,
                        })
                    )
                    .then((response) => {
                        const xclyList1 = response.data.data;
                        this.xclyList = xclyList1;
                        this.$nextTick(() => {
                            new Swiper(".big-walk", {
                                spaceBetween: 10,
                                slidesPerView: 2.5,
                                // loop: true,
                                observer: true,
                                observeParents: true,
                            });
                        });
                    });
            },
            // 视觉印象
            vrList() {
                const vrEsQuery = new EsQuery();
                const querystring13 = require("querystring");
                vrEsQuery
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, vrEsQuery.and, false)
                    .addString("publishStatus", 1, vrEsQuery.asc, false)
                    .addSort("weight", vrEsQuery.desc, false);

                vrEsQuery.addPage(0, 10);
                vrEsQuery.addStartWith(
                    "catalogCode",
                    "00000000,1720424059487",
                    vrEsQuery.and,
                    false
                );
                const vrJsList = JSON.stringify(vrEsQuery.getArray());

                this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring13.stringify({
                            indexName: this.INDEX_NAME_TYPE.newsList,
                            esJsonQuery: vrJsList,
                        })
                    )
                    .then((res) => {
                        let vrList = res.data.data;
                        this.vrListData = vrList.map((item) => item._source);
                    });
            },
            // 热门资讯
            newList() {
                const newsEsQuery = new EsQuery();
                const querystring4 = require("querystring");
                newsEsQuery
                    .addStartWith(
                        "deptCode",
                        this.DEPT_CODE.DEPTCODE,
                        newsEsQuery.and,
                        false
                    )
                    .addString("publishStatus", 1, newsEsQuery.asc, false)
                    .addSort("createdDate", newsEsQuery.desc, false);

                newsEsQuery.addPage(0, 10);
                newsEsQuery
                    .addStartWith(
                        "catalogCode",
                        "00000000,1720766038703",
                        newsEsQuery.and,
                        false
                    ) //根据areaCode筛选数据
                // .addString(
                //   "catalogId",
                //   "4bf1f70c9bd04e7aaa3514427a39a8e6",
                //   newsEsQuery.and,
                //   false
                // );
                const newsJsList = JSON.stringify(newsEsQuery.getArray());

                this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring4.stringify({
                            indexName: this.INDEX_NAME_TYPE.newsList,
                            esJsonQuery: newsJsList,
                        })
                    )
                    .then((res) => {
                        let newsList = res.data.data;
                        this.newListData = newsList.map((item) => item._source);
                        this.$nextTick(() => {
                            new Swiper(".news-swiper", {
                                slidesPerView: "auto",
                                loopedSlides: 8,
                                direction: "vertical",
                                loop: true,
                                speed: 1000,
                                autoplay: 2000,
                            }); // 通知公告
                        });
                    });
            },
            getVideo() {
                const _this = this;
                const newsEsQuery = new EsQuery();
                const querystring7 = require("querystring");
                newsEsQuery
                    .addStartWith(
                        "deptCode",
                        this.DEPT_CODE.DEPTCODE,
                        newsEsQuery.and,
                        false
                    )
                    .addString("publishStatus", 1, newsEsQuery.asc, false)
                    .addSort("createdDate", newsEsQuery.desc, false);

                newsEsQuery.addPage(0, 10);
                newsEsQuery.addStartWith(
                    "catalogCode",
                    "00000000,1720488067268",
                    newsEsQuery.and,
                    false
                );
                const newsJsList3 = JSON.stringify(newsEsQuery.getArray());

                this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring7.stringify({
                            indexName: this.INDEX_NAME_TYPE.newsList,
                            esJsonQuery: newsJsList3,
                        })
                    )
                    .then((res) => {
                        let videoList = res.data.data;
                        _this.videoList = videoList.map((item) => item._source);
                        _this.$nextTick(() => {
                            new Swiper(".big-video", {
                                slidesPerView: "auto",
                                spaceBetween: 10,
                                // loop: true,
                                observer: true,
                                observeParents: true,
                            });
                        });
                    });
            },
            // 推荐酒店
            getCommentList() {
                const _this = this;
                const querystring5 = require("querystring");
                const houseEsQuery = new EsQuery();
                houseEsQuery
                    // .addStartWith(
                    //   "category",
                    //   _this.XXCJ_TYPE_CODE.JDMS,
                    //   houseEsQuery.and,
                    //   false
                    // )
                    .addStartWith(
                        "deptCode",
                        _this.DEPT_CODE.DEPTCODE,
                        houseEsQuery.and,
                        false
                    )
                    .addPage(0, 500);
                const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray());
                _this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring5.stringify({
                            indexName: _this.INDEX_NAME_TYPE.hotelList,
                            esJsonQuery: houseEsJsonQuery,
                        })
                    )
                    .then((res) => {
                        const data = res.data.data;
                        let hotelList = data.filter((item) => item._source.score != "0.00");
                        _this.hotelList = hotelList.map((item) => item._source);


                        // _this.hotelList = _this.hotelList.slice(3,6)
                    });
            },
            //线路
            getlineList() {
                const _this = this;
                const querystring12 = require("querystring");
                const lineEsQuery = new EsQuery();

                // 排序筛选
                // foodEsQuery.addSort(_this.sortData[_this.sortIdx].sort, foodEsQuery[_this.sortData[_this.sortIdx].type], false)
                lineEsQuery
                    .addStartWith("catalogCode", "00000000,1720581749960", lineEsQuery.and, false)
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, lineEsQuery.and, false)
                    .addString("publishStatus", 1, lineEsQuery.asc, false)
                    .addSort("weight", lineEsQuery.desc, false)
                    .addPage(0, 6);
                const lineEsJsonQuery = JSON.stringify(lineEsQuery.getArray());

                _this.$http
                    .post(
                        "/api/wtcp-kb/pub/doc/search",
                        querystring12.stringify({
                            indexName: _this.INDEX_NAME_TYPE.newsList,
                            esJsonQuery: lineEsJsonQuery,
                        })
                    )
                    .then((res) => {
                        const routeList = res.data.data;
                        this.routeList = routeList;
                        _this.$nextTick(() => {
                            new Swiper(".other-swiper", {
                                slidesPerView: 2,
                                spaceBetween: 20,
                                freeMode: false,
                            });
                        });
                    });
            },
        },
    };
